import BarChart from "../../../../components/charts/BarChart";
import {
    barChartDataDailyTraffic, barChartDataDevicePerProduct,
    barChartDataDevicesPerProduct,
    barChartOptionsDailyTraffic, barChartOptionsDevicePerProduct, barChartOptionsDevicesPerProduct
} from "../../../../variables/charts";
import Card from "../../../../components/card";
import axios from "axios";
import {useEffect, useState} from "react";
import {useUserAuth} from "../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";

const DevicesPerProductGraph = () => {

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
    const secretKey = "cromptonssecretkey";

    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
    const navigate = useNavigate();

    let [dataCount, setDataCount] = useState([]);
    let [productCatalog, setProductCatalog] = useState([])
    let [isLoading, setIsLoading] = useState(true)
    let [options, setOptions] = useState([]);
    const [errorMessage, setErrorMessage] = useState("")

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }

    function getDevicesPerProduct() {
        if ((accesscontrollevel.toString() === "1") || (accesscontrollevel.toString() === "3") || (accesscontrollevel.toString() === "5")) {
            setIsLoading(true)
            const chartLabels = [];
            const count = [];
            const url = CROMPTON_ANALYTICS_URL + "v1/device/devicesPerProduct/";

            axios({
                method: "GET", url: url, headers: {
                    Authorization: decryptedValue,
                }

            }).then((res) => {
                //console.log(res.data)
                for (let i in res.data) {
                    if(res.data[i].devices !== 0){
                        chartLabels.push(res.data[i].productName.replace(/UCP|Wi-Fi|IoT/gi, ""))
                        count.push(res.data[i].devices);
                    }
                    //count[i] = res.data[i].devices
                }

                //console.log(count)
                setDataCount(count)
                dataCount = count
                //console.log(chartLabels)


                setOptions(chartLabels)
                options = chartLabels

                setIsLoading(false)


                //console.log(productCatalog)

                //getPlWiseDistributionTrend()
                /*console.log("Data labels: ", chartLabels)
                console.log("Data values: ", count)*/

            }).catch((error) => {
                setIsLoading(false)
                //console.log(error)
                if (error.response.data.status === "401" || error.response.data.status === "403") {
                    handleLogOut();
                }
            })

        } else {
            //console.log("Inside stats non admin")
            //setErrorMessage("You do not have permission to view this. Please contact admin.")
        }
    }

    useEffect(() => {

        getDevicesPerProduct()


    }, [""])

    return (
        <Card extra="w-full h-full  pb-7 p-[20px]">
            <div className="flex flex-row justify-between">
                <div className="ml-1 pt-2">
                    <p className="text-xl font-medium leading-4 text-black-400">
                        <b>Devices Per Product</b>
                    </p>
                    {/*<p className="text-[34px] font-bold text-navy-700 dark:text-white">
            2.579{" "}
            <span className="text-sm font-medium leading-6 text-gray-600">
              Visitors
            </span>
          </p>*/}
                </div>
                {/*<div className="mt-2 flex items-start">
          <div className="flex items-center text-sm text-green-500">
            <MdArrowDropUp className="h-5 w-5" />
            <p className="font-bold"> +2.45% </p>
          </div>
        </div>*/}
            </div>

            <div className="h-[300px] w-full pt-10 pb-0">
                {!isLoading &&
                    <BarChart
                        chartData={[
                            {
                                name: "Device Count",
                                data: dataCount
                            }
                        ]}
                        chartOptions={{
                            chart: {
                                toolbar: {
                                    show: true,
                                },
                            },
                            tooltip: {
                                style: {
                                    fontSize: "12px",
                                    fontFamily: undefined,
                                    backgroundColor: "#000000"
                                },
                                onDatasetHover: {
                                    style: {
                                        fontSize: "12px",
                                        fontFamily: undefined,
                                    },
                                },
                                theme: "dark",
                            },
                            xaxis: {
                                categories: options,
                                show: true,
                                labels: {
                                    show: true,
                                    style: {
                                        colors: "#A3AED0",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                    },
                                },
                                axisBorder: {
                                    show: false,
                                },
                                axisTicks: {
                                    show: false,
                                },
                            },
                            yaxis: {
                                show: true,
                                color: "black",
                                labels: {
                                    show: true,
                                    style: {
                                        colors: "#CBD5E0",
                                        fontSize: "14px",
                                    },
                                },
                            },
                            grid: {
                                show: false,
                                strokeDashArray: 5,
                                yaxis: {
                                    lines: {
                                        show: true,
                                    },
                                },
                                xaxis: {
                                    lines: {
                                        show: true,
                                    },
                                },
                            },
                            fill: {
                                type: "gradient",
                                gradient: {
                                    type: "vertical",
                                    shadeIntensity: 1,
                                    opacityFrom: 0.7,
                                    opacityTo: 0.9,
                                    colorStops: [
                                        [
                                            {
                                                offset: 0,
                                                color: "#0b83b5",
                                                opacity: 1,
                                            },
                                            {
                                                offset: 100,
                                                color: "#0b83b5",
                                                opacity: 0.28,
                                            },
                                        ],
                                    ],
                                },
                            },
                            dataLabels: {
                                enabled: false,
                            },
                            plotOptions: {
                                bar: {
                                    borderRadius: 4,
                                    columnWidth: "40px",
                                },
                            },
                        }}
                    />
                }

            </div>
        </Card>
    );
};

export default DevicesPerProductGraph;
